import PrimeReact, { addLocale, locale } from "primereact/api";

export const setupLocales = () => {
  addLocale("bg", {
    firstDayOfWeek: 1,
    dayNames: [
      "Неделя",
      "Понеделник",
      "Вторник",
      "Сряда",
      "Четвъртък",
      "Петък",
      "Събота",
    ],
    dayNamesShort: ["Нед", "Пон", "Вто", "Сря", "Чет", "Пет", "Съб"],
    dayNamesMin: ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
    monthNames: [
      "Януари",
      "Февруари",
      "Март",
      "Април",
      "Май",
      "Юни",
      "Юли",
      "Август",
      "Септември",
      "Октомври",
      "Ноември",
      "Декември",
    ],
    monthNamesShort: [
      "Ян",
      "Фев",
      "Мар",
      "Апр",
      "Май",
      "Юни",
      "Юли",
      "Авг",
      "Сеп",
      "Окт",
      "Ное",
      "Дек",
    ],
    today: "Днес",
    clear: "Изчисти",
    dateFormat: "dd/mm/yy",
    weekHeader: "Седмица",
  });

  locale("bg");
};
